export const todoListRoute = {
  path: "/todo",
  name: "todo-list",
  component: () => import("../ui/todo/todo-list.vue")
};